exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail-container {\n  text-align: center;\n  overflow: auto;\n  white-space: nowrap; }\n  .thumbnail-container .thumbnail {\n    width: 200px;\n    height: 200px;\n    position: relative;\n    display: inline-block; }\n  .thumbnail-container .thumbnail img {\n      max-width: 100%;\n      max-height: 100%;\n      border-radius: 5px;\n      cursor: pointer;\n      -webkit-transition: 0.3s;\n      transition: 0.3s;\n      cursor: pointer; }\n  .thumbnail-container .thumbnail img:hover {\n      opacity: 0.7; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/gallery/gallery.component.scss
// module id = ../../../../../src/app/shared/gallery/gallery.component.scss
// module chunks = main